const CopyIcon = () => {
    return (
        <div>
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.0156 13.9V16.9C17.0156 20.9 15.4156 22.5 11.4156 22.5H7.61562C3.61562 22.5 2.01562 20.9 2.01562 16.9V13.1C2.01562 9.1 3.61562 7.5 7.61562 7.5H10.6156" stroke="#6B6B6B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M17.0152 13.9H13.8152C11.4152 13.9 10.6152 13.1 10.6152 10.7V7.5L17.0152 13.9Z" stroke="#6B6B6B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.6152 2.5H15.6152" stroke="#6B6B6B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.01562 5.5C7.01562 3.84 8.35563 2.5 10.0156 2.5H12.6356" stroke="#6B6B6B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22.0161 8.5V14.69C22.0161 16.24 20.7561 17.5 19.2061 17.5" stroke="#6B6B6B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22.0156 8.5H19.0156C16.7656 8.5 16.0156 7.75 16.0156 5.5V2.5L22.0156 8.5Z" stroke="#6B6B6B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
    )
}

export default CopyIcon;